import React, { useEffect, useState } from 'react';
import { Loader2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { WhatsApp } from '@mui/icons-material';
import { useFluidFormClient } from '../fluidForm.client';
const WhatsAppWindow = ({ background }) => {
    const [customerWhatsAppDeepLink, setCustomerWhatsAppDeepLink] = useState();
    const [loading, setLoading] = useState(false);
    const client = useFluidFormClient();
    const getCustomerWhatsAppDeepLink = async () => {
        setLoading(true);
        let displayPhoneNumber;
        try {
            displayPhoneNumber = await client.getWhatsAppDisplayPhoneNumber();
            if (!displayPhoneNumber) {
                setLoading(false);
                return;
            }
        }
        catch (error) {
            console.warn('Failed to get customer WhatsApp deep link, Using test number:');
            displayPhoneNumber = '15551946254';
        }
        // <Link to="https://wa.me/15551946254?text=Hi" target="_blank" >
        setCustomerWhatsAppDeepLink(`https://wa.me/${displayPhoneNumber}?text=${encodeURIComponent("Hi!")}`);
        setLoading(false);
    };
    useEffect(() => {
        getCustomerWhatsAppDeepLink();
    }, []);
    let backgroundClass = background === 'white' ? 'bg-white' : 'bg-gray-900';
    let textColor = background === 'white' ? 'text-gray-600' : 'text-white';
    if (!loading && !customerWhatsAppDeepLink) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("button", { onClick: () => {
        }, disabled: loading || !customerWhatsAppDeepLink, className: `w-10 h-10 rounded-full ${backgroundClass} border border-gray-200 hover:border-orange-300 hover:bg-orange-50 flex items-center justify-center transition-all duration-300 group shadow-sm ${!customerWhatsAppDeepLink ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`, title: !customerWhatsAppDeepLink ? "Processing..." : "Continue on WhatsApp" }, !customerWhatsAppDeepLink ? (React.createElement(Loader2Icon, { className: `w-5 h-5 ${textColor} animate-spin` })) : (React.createElement(Link, { to: customerWhatsAppDeepLink, target: "_blank", title: "Continue on WhatsApp" },
        React.createElement(WhatsApp, { className: `w-5 h-5 ${textColor} group-hover:text-orange-500` })))));
};
export default WhatsAppWindow;
